import { useState } from "react";

export const useCheckSubitems = () => {
  const [processSubitems, setProcessSubitems] = useState(true);

  return {
    processSubitems,
    setProcessSubitems,
  };
};
